import { render, staticRenderFns } from "./productosLeechero.vue?vue&type=template&id=56cb3652&scoped=true&"
import script from "./productosLeechero.vue?vue&type=script&lang=js&"
export * from "./productosLeechero.vue?vue&type=script&lang=js&"
import style0 from "./productosLeechero.vue?vue&type=style&index=0&id=56cb3652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb3652",
  null
  
)

export default component.exports